// extracted by mini-css-extract-plugin
export var headerCell = "_3r-1";
export var loadingSpinnerContainer = "_3r-4";
export var rowWrapper = "_3r-3";
export var standaloneTable = "_3r-5";
export var table = "_3r-0";
export var white = "_3r-2";